<script lang="ts">
  import { ListLayoutRelative, ListLayoutSingle } from '@shared/ui/list';

  import type { Auctions } from '@entities/auction';
  import { AuctionCard, auctionCardModel } from '@entities/auction/auction-card';

  export let auctions: Auctions['data'];
</script>

<div class="hidden md:block">
  <ListLayoutRelative products="{auctions}" let:product>
    {#key product.id}
      <AuctionCard
        id="{product.id}"
        status="{product.status}"
        startDate="{product.start_date}"
        duration="{product.duration}"
        bestBid="{product.best_bid}"
        initialPrice="{Number(product.initial_bid_value) / 10 ** 6}"
        artAsset="{auctionCardModel.mapApiArtAsset(product.art_asset)}"
      />
    {/key}
  </ListLayoutRelative>
</div>

<div class="md:hidden">
  <ListLayoutSingle products="{auctions}" let:product>
    {#key product.id}
      <AuctionCard
        id="{product.id}"
        status="{product.status}"
        startDate="{product.start_date}"
        duration="{product.duration}"
        bestBid="{product.best_bid}"
        initialPrice="{Number(product.initial_bid_value) / 10 ** 6}"
        artAsset="{auctionCardModel.mapApiArtAsset(product.art_asset)}"
      />
    {/key}
  </ListLayoutSingle>
</div>
